import { render, staticRenderFns } from "./material_report.vue?vue&type=template&id=17cd76cd&scoped=true"
import script from "./material_report.vue?vue&type=script&lang=js"
export * from "./material_report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cd76cd",
  null
  
)

export default component.exports